import axios from "axios";
import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import { Link } from "react-router-dom";
import Select from "react-select";
import {
    Button,
    Col,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Row,
    UncontrolledDropdown,
} from "reactstrap";
import { getStoredAuthUser } from "../../utils/backendApi";

const ArticlesFilter = ({ articles, setFilteredArticles }) => {
  const token = getStoredAuthUser()?.access ?? null;

  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    const checkTokenValidity = async () => {
      try {
        const response = await axios.get(
          "https://prod.leconseillerdubtp.com/api/v1/categories/",
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );
        setCategoryList(response);
      } catch (error) {
        console.error(error);
      }
    };
    checkTokenValidity();
  }, []);

  const categories = Array.from(
    new Set(articles.map((article) => article.category))
  ); // Obtient une liste de catégories uniques

  const handleCategoryFilter = (category) => {
    const filtered = articles.filter(
      (article) => article.category === category
    );
    setFilteredArticles(filtered);
  };

  return (
    <div>
      <h3>Filtrer par Catégorie :</h3>
      {categories.map((category) => (
        <button key={category} onClick={() => handleCategoryFilter(category)}>
          {category}
        </button>
      ))}
      <button onClick={() => setFilteredArticles(articles)}>
        Réinitialiser
      </button>
    </div>
  );
};
export default ArticlesFilter;

const ProductsGlobalFilter = () => {
  return (
    <React.Fragment>
      <div className="col-sm-auto ms-auto">
        <div>
          <Link to="/articles-add" className="btn btn-warning">
            <i className="ri-add-line align-bottom me-1"></i> Ajouter un article
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

const CreateUserLink = () => {
  return (
    <React.Fragment>
      <div className="col-sm-auto ms-auto">
        <div>
          <Link to="/pages-team-add-user" className="btn btn-warning">
            <i className="ri-add-line align-bottom me-1"></i> Ajouter un
            utilisateur
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

const CreateUserCategorie = () => {
  return (
    <React.Fragment>
      <div className="col-sm-auto ms-auto">
        <div>
          <Link to="/utilisateurs-categories-add" className="btn btn-warning">
            <i className="ri-add-line align-bottom me-1"></i> Ajouter une
            catégorie d'institutions
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

const CreateUserSubcategorie = () => {
  return (
    <React.Fragment>
      <div className="col-sm-auto ms-auto">
        <div>
          <Link to="/utilisateurs-institutions-add" className="btn btn-warning">
            <i className="ri-add-line align-bottom me-1"></i> Ajouter une
            institution
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

const TypesAbonnementGlobalFilter = () => {
  return (
    <React.Fragment>
      <div className="col-sm-auto ms-auto">
        <div>
          <Link to="/subscription-types-add" className="btn btn-warning">
            <i className="ri-add-line align-bottom me-1"></i> Ajouter un type
            d'abonnement
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

const FormationsGlobalFilter = () => {
  return (
    <React.Fragment>
      <div className="col-sm-auto ms-auto">
        <div>
          <Link to="/formations-add" className="btn btn-warning">
            <i className="ri-add-line align-bottom me-1"></i> Ajouter une
            formation
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

const InnovationsGlobalFilter = () => {
  return (
    <React.Fragment>
      <div className="col-sm-auto ms-auto">
        <div>
          <Link to="/innovations-add" className="btn btn-warning">
            <i className="ri-add-line align-bottom me-1"></i> Ajouter une
            innovation
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

const PublicitiesGlobalFilter = () => {
  return (
    <React.Fragment>
      <div className="col-sm-auto ms-auto">
        <div>
          <Link to="/advertisements-add" className="btn btn-warning">
            <i className="ri-add-line align-bottom me-1"></i> Ajouter une
            publicité
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

const CategoriesGlobalFilter = () => {
  return (
    <React.Fragment>
      <div className="col-sm-auto ms-auto">
        <div>
          <Link to="/categories-add" className="btn btn-warning">
            <i className="ri-add-line align-bottom me-1"></i> Ajouter une
            catégorie
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

const MetiersGlobalFilter = ({ modal }) => {
  return (
    <React.Fragment>
      <div className="col-sm-auto ms-auto">
        <div>
          <button className="btn btn-warning" onClick={modal}>
            <i className="ri-add-fill align-bottom me-1"></i> Ajouter un type de
            métier
          </button>
        </div>
      </div>
      <div className="col-sm-auto ms-auto">
        <div>
          <div to="/jobs-add" className="btn btn-warning">
            <i className="ri-add-line align-bottom me-1"></i> Ajouter un métier
            professionnel
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
const CollaborateurGlobalFilter = () => {
  return (
    <React.Fragment>
      <div className="col-sm-auto ms-auto">
        <div>
          <Link to="/collaborateurs-add" className="btn btn-warning">
            <i className="ri-add-line align-bottom me-1"></i> Ajouter un
            collaborateur
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

const ExpertGlobalFilter = () => {
  return (
    <React.Fragment>
      <div className="col-sm-auto ms-auto">
        <div>
          <Link to="/experts-add" className="btn btn-warning">
            <i className="ri-add-line align-bottom me-1"></i> Ajouter un Expert
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

const RecrutementsGlobalFilter = () => {
  return (
    <React.Fragment>
      <div className="col-sm-auto ms-auto">
        <div>
          <Link to="/recruitments-add" className="btn btn-warning">
            <i className="ri-add-line align-bottom me-1"></i> Ajouter une offre
            d'emploi
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

const AppelOffressGlobalFilter = () => {
  return (
    <React.Fragment>
      <div className="col-sm-auto ms-auto">
        <div>
          <Link to="/appels-offres-add" className="btn btn-warning">
            <i className="ri-add-line align-bottom me-1"></i> Ajouter un appel
            d'offre
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

const CustomersGlobalFilter = () => {
  const [customerStatus, setcustomerStatus] = useState(null);

  function handlecustomerStatus(customerStatus) {
    setcustomerStatus(customerStatus);
  }

  const customerstatus = [
    {
      options: [
        { label: "Status", value: "Status" },
        { label: "All", value: "All" },
        { label: "Active", value: "Active" },
        { label: "Block", value: "Block" },
      ],
    },
  ];
  return (
    <React.Fragment>
      <Col xl={7}>
        <Row className="g-3">
          <Col sm={4}>
            <div className="">
              <Flatpickr
                className="form-control"
                id="datepicker-publish-input"
                placeholder="Select a date"
                options={{
                  altInput: true,
                  altFormat: "F j, Y",
                  mode: "multiple",
                  dateFormat: "d.m.y",
                }}
              />
            </div>
          </Col>

          <Col sm={4}>
            <div>
              <Select
                value={customerStatus}
                onChange={(e) => {
                  handlecustomerStatus(e.value);
                }}
                options={customerstatus}
                name="choices-single-default"
                id="idStatus"
              ></Select>
            </div>
          </Col>

          <Col sm={4}>
            <div>
              <button type="button" className="btn btn-primary w-100">
                {" "}
                <i className="ri-equalizer-fill me-2 align-bottom"></i>
                Filters
              </button>
            </div>
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};
const OrderGlobalFilter = () => {
  const [orderStatus, setorderStatus] = useState([]);
  const [orderPayement, setorderPayement] = useState(null);
  function handleorderStatus(orderstatus) {
    setorderStatus(orderstatus);
  }

  function handleorderPayement(orderPayement) {
    setorderPayement(orderPayement);
  }

  const orderstatus = [
    {
      options: [
        { label: "Status", value: "Status" },
        { label: "All", value: "All" },
        { label: "Pending", value: "Pending" },
        { label: "Inprogress", value: "Inprogress" },
        { label: "Cancelled", value: "Cancelled" },
        { label: "Pickups", value: "Pickups" },
        { label: "Returns", value: "Returns" },
        { label: "Delivered", value: "Delivered" },
      ],
    },
  ];

  const orderpayement = [
    {
      options: [
        { label: "Select Payment", value: "Select Payment" },
        { label: "All", value: "All" },
        { label: "Mastercard", value: "Mastercard" },
        { label: "Paypal", value: "Paypal" },
        { label: "Visa", value: "Visa" },
        { label: "COD", value: "COD" },
      ],
    },
  ];
  return (
    <React.Fragment>
      <Col sm={6} className="col-xxl-2">
        <div>
          <Flatpickr
            className="form-control"
            id="datepicker-publish-input"
            placeholder="Select a date"
            options={{
              altInput: true,
              altFormat: "F j, Y",
              mode: "multiple",
              dateFormat: "d.m.y",
            }}
          />
        </div>
      </Col>

      <Col sm={4} className="col-xxl-2">
        <div>
          <Select
            value={orderStatus}
            onChange={(e) => {
              handleorderStatus(e);
            }}
            options={orderstatus}
            name="choices-single-default"
            id="idStatus"
          ></Select>
        </div>
      </Col>

      <Col sm={4} className="col-xxl-2">
        <div>
          <Select
            value={orderPayement}
            onChange={() => {
              handleorderPayement();
            }}
            options={orderpayement}
            name="choices-payment-default"
            id="idPayment"
          ></Select>
        </div>
      </Col>

      <Col sm={4} className="col-xxl-1">
        <div>
          <button type="button" className="btn btn-primary w-100">
            {" "}
            <i className="ri-equalizer-fill me-1 align-bottom"></i>
            Filters
          </button>
        </div>
      </Col>
    </React.Fragment>
  );
};

const ContactsGlobalFilter = () => {
  const [sortBy, setsortBy] = useState(null);

  function handlesortBy(sortBy) {
    setsortBy(sortBy);
  }

  const sortbyname = [
    {
      options: [
        { label: "Prospect", value: "Prospect" },
        { label: "Client", value: "Client" },
        { label: "Fournisseur", value: "Fournisseur" },
        { label: "Partenaire", value: "Partenaire" },
      ],
    },
  ];
  return (
    <React.Fragment>
      <div className="col-md-auto ms-auto">
        <div className="d-flex align-items-center gap-2">
          <span className="text-muted">Sort by: </span>
          <Select
            className="mb-0"
            value={sortBy}
            onChange={() => {
              handlesortBy();
            }}
            options={sortbyname}
            id="choices-single-default"
          ></Select>
        </div>
      </div>
    </React.Fragment>
  );
};

const CompaniesGlobalFilter = () => {
  const [sortBy, setsortBy] = useState("Owner");

  function handlesortBy(sortBy) {
    setsortBy(sortBy);
  }

  const sortbyname = [
    {
      options: [
        { label: "Owner", value: "Owner" },
        { label: "Company", value: "Company" },
        { label: "Location", value: "Location" },
      ],
    },
  ];
  return (
    <React.Fragment>
      <div className="col-md-auto ms-auto">
        <div className="d-flex align-items-center gap-2">
          <span className="text-muted">Sort by: </span>
          <Select
            className="mb-0"
            value={sortBy}
            onChange={() => {
              handlesortBy();
            }}
            options={sortbyname}
            id="choices-single-default"
          ></Select>
        </div>
      </div>
    </React.Fragment>
  );
};

const CryptoOrdersGlobalFilter = () => {
  return (
    <React.Fragment>
      <Col xl={2} md={6}>
        <div className="input-group">
          <span className="input-group-text" id="basic-addon1">
            <i className="ri-calendar-2-line"></i>
          </span>
          <Flatpickr
            placeholder="Select date"
            className="form-control"
            options={{
              mode: "range",
              dateFormat: "d M, Y",
            }}
          />
        </div>
      </Col>
      <Col xl={2} md={4}>
        <select
          className="form-control"
          data-choices
          data-choices-search-false
          name="choices-single-default"
          id="choices-single-default"
        >
          <option defaultValue="">Select Type</option>
          <option value="Buy">Sell</option>
          <option value="Sell">Buy</option>
        </select>
      </Col>
      <Col xl={2} md={4}>
        <select
          className="form-control"
          data-choices
          data-choices-search-false
          name="choices-single-default2"
          id="choices-single-default2"
        >
          <option defaultValue="">Select Status</option>
          <option value="Successful">Successful</option>
          <option value="Cancelled">Cancelled</option>
        </select>
      </Col>
      <Col xl={1} md={4}>
        <button className="btn btn-success w-100">Filters</button>
      </Col>
    </React.Fragment>
  );
};

const InvoiceListGlobalSearch = () => {
  const [isStatus, setisStatus] = useState(null);

  function handleisStatus(isStatus) {
    setisStatus(isStatus);
  }

  const allstatus = [
    {
      options: [
        { label: "Status", value: "Status" },
        { label: "All", value: "All" },
        { label: "Unpaid", value: "Unpaid" },
        { label: "Paid", value: "Paid" },
        { label: "Cancel", value: "Cancel" },
        { label: "Refund", value: "Refund" },
      ],
    },
  ];
  return (
    <React.Fragment>
      <Col sm={4} xxl={3}>
        <Flatpickr
          className="form-control bg-light border-light"
          id="datepicker-publish-input"
          placeholder="Select a date"
          options={{
            altInput: true,
            altFormat: "F j, Y",
            mode: "multiple",
            dateFormat: "d.m.y",
          }}
        />
      </Col>

      <Col sm={4} xxl={3}>
        <div className="input-light">
          <Select
            value={isStatus}
            onChange={() => {
              handleisStatus();
            }}
            options={allstatus}
            name="choices-single-default"
            id="idStatus"
          ></Select>
        </div>
      </Col>

      <Col sm={4} xxl={1}>
        <Button color="primary" className="w-100">
          <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
        </Button>
      </Col>
    </React.Fragment>
  );
};

const TicketsListGlobalFilter = () => {
  return (
    <React.Fragment>
      <Col xxl={3} sm={4}>
        <Flatpickr
          className="form-control"
          placeholder="Select date range"
          options={{
            mode: "range",
            dateFormat: "d M, Y",
          }}
        />
      </Col>
      <Col xxl={3} sm={4}>
        <div className="input-light">
          <select
            className="form-control"
            data-choices
            data-choices-search-false
            name="choices-single-default"
            id="idStatus"
          >
            <option value="">Status</option>
            <option defaultValue="all">All</option>
            <option value="Open">Open</option>
            <option value="Inprogress">Inprogress</option>
            <option value="Closed">Closed</option>
            <option value="New">New</option>
          </select>
        </div>
      </Col>
      <Col xxl={1} sm={4}>
        <button type="button" className="btn btn-primary w-100">
          {" "}
          <i className="ri-equalizer-fill me-1 align-bottom"></i>
          Filters
        </button>
      </Col>
    </React.Fragment>
  );
};

const NFTRankingGlobalFilter = () => {
  return (
    <React.Fragment>
      <Col xxl={2} sm={4} className="ms-auto">
        <div>
          <select
            className="form-control"
            data-choices
            data-choices-search-false
            name="choices-single-default"
            id="idStatus"
          >
            <option value="All Time" defaultValue>
              All Time
            </option>
            <option value="1 Day">1 Day</option>
            <option value="7 Days">7 Days</option>
            <option value="15 Days">15 Days</option>
            <option value="1 Month">1 Month</option>
            <option value="6 Month">6 Month</option>
          </select>
        </div>
      </Col>
    </React.Fragment>
  );
};

const TaskListGlobalFilter = () => {
  return (
    <React.Fragment>
      <div className="col-xxl-2 col-sm-3">
        <Flatpickr
          placeholder="Select date range"
          className="form-control bg-light border-light"
          options={{
            mode: "range",
            dateFormat: "d M, Y",
          }}
        />
      </div>

      <div className="col-xxl-2 col-sm-2">
        <div className="input-light">
          <select
            className="form-control"
            data-choices
            data-choices-search-false
            name="status"
            id="idStatus"
          >
            <option value="">Status</option>
            <option defaultValue="all">Tous</option>
            <option value="nouveau">Nouveau</option>
            <option value="en attente">En attente</option>
            <option value="en cours">En cours</option>
            <option value="complet">Complet</option>
          </select>
        </div>
      </div>
      <div className="col-xxl-1 col-sm-2">
        <button type="button" className="btn btn-primary w-100">
          {" "}
          <i className="ri-equalizer-fill me-1 align-bottom"></i>
          Filtrer
        </button>
      </div>
    </React.Fragment>
  );
};

const LeadsGlobalFilter = ({ onClickDelete }) => {
  return (
    <React.Fragment>
      <div className="col-sm-auto ms-auto">
        <div className="hstack gap-2">
          <button className="btn btn-soft-danger" onClick={onClickDelete}>
            <i className="ri-delete-bin-2-line"></i>
          </button>
          <button
            type="button"
            className="btn btn-info"
            //  onClick={toggleInfo}
          >
            <i className="ri-filter-3-line align-bottom me-1"></i> Fliters
          </button>
          <button
            type="button"
            className="btn btn-success add-btn"
            id="create-btn"
            // onClick={() => { setIsEdit(false); toggle(); }}
          >
            <i className="ri-add-line align-bottom me-1"></i> Add Leads
          </button>
          <UncontrolledDropdown>
            <DropdownToggle
              className="btn btn-soft-info btn-icon fs-14"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="ri-settings-4-line"></i>
            </DropdownToggle>
            <DropdownMenu>
              <li>
                <DropdownItem>Copy</DropdownItem>
              </li>
              <li>
                <DropdownItem>Move to pipline</DropdownItem>
              </li>
              <li>
                <DropdownItem>Add to exceptions</DropdownItem>
              </li>
              <li>
                <DropdownItem>Switch to common form view</DropdownItem>
              </li>
              <li>
                <DropdownItem>Reset form view to default</DropdownItem>
              </li>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </div>
    </React.Fragment>
  );
};

export {
  AppelOffressGlobalFilter,
  CategoriesGlobalFilter,
  CollaborateurGlobalFilter,
  CompaniesGlobalFilter,
  ContactsGlobalFilter,
  CreateUserCategorie,
  CreateUserSubcategorie,
  CreateUserLink,
  CryptoOrdersGlobalFilter,
  CustomersGlobalFilter,
  ExpertGlobalFilter,
  FormationsGlobalFilter,
  InnovationsGlobalFilter,
  InvoiceListGlobalSearch,
  LeadsGlobalFilter,
  MetiersGlobalFilter,
  NFTRankingGlobalFilter,
  OrderGlobalFilter,
  ProductsGlobalFilter,
  PublicitiesGlobalFilter,
  RecrutementsGlobalFilter,
  TaskListGlobalFilter,
  TicketsListGlobalFilter,
  TypesAbonnementGlobalFilter,
};
